function isPair(cardToCheck, handToCheck) {
  const pairedCards = getPairedCards(handToCheck)
  if (pairedCards.length > 0) {
    const paired = pairedCards.find(card => {
      return (card.value === cardToCheck.value)
    })
    if (paired) {
      return true
    }
  }
  return false
}

function getPairedCards(hand) {
  let pairedValues = new Array()

  // Check Rows
  if (hasValidRows(hand)) {
    pairedValues = [...pairedValues, ...checkPairs(hand.slice(0, 3))]
    pairedValues = [...pairedValues, ...checkPairs(hand.slice(3, 6))]
    pairedValues = [...pairedValues, ...checkPairs(hand.slice(6))]
  }

  // Check Cols
  if (hasValidCols(hand)) {
    pairedValues = [...pairedValues, ...checkPairs([hand[0], hand[3], hand[6]])]
    pairedValues = [...pairedValues, ...checkPairs([hand[1], hand[4], hand[7]])]
    pairedValues = [...pairedValues, ...checkPairs([hand[2], hand[5], hand[8]])]
  }

  return pairedValues
}

function hasValidRows(hand) {
  if (hand[2].displayClass !== 'transparent') {
    return true
  }
  return false
}

function hasValidCols(hand) {
  if (hand[6].displayClass !== 'transparent') {
    return true
  }
  return false
}

function checkPairs(cards) {
  let pairedValues = new Array()

  if (compareCards(cards[0], cards[1])) {
    pairedValues.push(cards[0])
    pairedValues.push(cards[1])
  }
  if (compareCards(cards[0], cards[2])) {
    pairedValues.push(cards[0])
    pairedValues.push(cards[2])
  }
  if (compareCards(cards[1], cards[2])) {
    pairedValues.push(cards[1])
    pairedValues.push(cards[2])
  }
  return pairedValues
}

function compareCards(card1, card2) {
  if (card1 && card2) {
    if (card1.displayClass === 'visible' && card2.displayClass === 'visible') {
      if (card1.value === card2.value) {
        return true
      }
    }
  }
  return
}

export {isPair}
